import SpecificHand from '@/services/hands/SpecificHand';
import constants from '@/services/constants';
import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default {
  inRangeWithFirstRank: function (generalHands, firstRank) {
    let suitedGeneralHandsInRangeWithFirstRank = this._getSuitedGeneralHandsInRangeWithFirstRank(generalHands, firstRank);
    let groupsOfConsecutiveSuitedGeneralHands = this._getGroupsOfConsecutiveSuitedGeneralHands(suitedGeneralHandsInRangeWithFirstRank);
    let textFromSuitedGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveSuitedGeneralHands(groupsOfConsecutiveSuitedGeneralHands);

    return textFromSuitedGeneralHandsWithFirstRank;
  },
  manuallyAddedWithFirstRank: function (generalHands, firstRank) {
    let suitedGeneralHandsManuallyAddedWithFirstRank = this._getSuitedGeneralHandsManuallyAddedWithFirstRank(generalHands, firstRank);
    let groupsOfConsecutiveSuitedGeneralHands = this._getGroupsOfConsecutiveSuitedGeneralHands(suitedGeneralHandsManuallyAddedWithFirstRank);
    let textFromSuitedGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveSuitedGeneralHands(groupsOfConsecutiveSuitedGeneralHands);

    return textFromSuitedGeneralHandsWithFirstRank;
  },
  manuallyRemovedWithFirstRank: function (generalHands, firstRank) {
    let suitedGeneralHandsManuallyRemovedWithFirstRank = this._getSuitedGeneralHandsManuallyRemovedWithFirstRank(generalHands, firstRank);
    let groupsOfConsecutiveSuitedGeneralHands = this._getGroupsOfConsecutiveSuitedGeneralHands(suitedGeneralHandsManuallyRemovedWithFirstRank);
    let textFromSuitedGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveSuitedGeneralHands(groupsOfConsecutiveSuitedGeneralHands);

    return textFromSuitedGeneralHandsWithFirstRank;
  },
  _getSuitedGeneralHandsInRangeWithFirstRank: function (generalHands, firstRank) {
    let listOfSuitedGeneralHandsInRangeWithFirstRank = [];

    constants.textSelectorLists.suited[firstRank].forEach(function (suitedGeneralHandWithFirstRankString) {
      let suitedGeneralHandWithFirstRank = generalHands.find(suitedGeneralHandWithFirstRankString);

      if (suitedGeneralHandWithFirstRank.inRange === true) {
        listOfSuitedGeneralHandsInRangeWithFirstRank.push(suitedGeneralHandWithFirstRank);
      } else if (suitedGeneralHandWithFirstRank.inRange === 'partial') {
        suitedGeneralHandWithFirstRank.forEachSpecificHandInRange(function (specificHand) {
          listOfSuitedGeneralHandsInRangeWithFirstRank.push(specificHand);
        });
      }
    });

    return listOfSuitedGeneralHandsInRangeWithFirstRank;
  },
  _getSuitedGeneralHandsManuallyAddedWithFirstRank: function (generalHands, firstRank) {
    let listOfSuitedGeneralHandsManuallyAddedWithFirstRank = [];

    constants.textSelectorLists.suited[firstRank].forEach(function (suitedGeneralHandWithFirstRankString) {
      let suitedGeneralHandWithFirstRank = generalHands.find(suitedGeneralHandWithFirstRankString);

      if (suitedGeneralHandWithFirstRank.manuallyAdded === true) {
        listOfSuitedGeneralHandsManuallyAddedWithFirstRank.push(suitedGeneralHandWithFirstRank);
      } else if (suitedGeneralHandWithFirstRank.manuallyAdded === 'partial') {
        suitedGeneralHandWithFirstRank.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyAdded) {
            listOfSuitedGeneralHandsManuallyAddedWithFirstRank.push(specificHand);
          }
        });
      }
    });

    return listOfSuitedGeneralHandsManuallyAddedWithFirstRank;
  },
  _getSuitedGeneralHandsManuallyRemovedWithFirstRank: function (generalHands, firstRank) {
    let listOfSuitedGeneralHandsManuallyRemovedWithFirstRank = [];

    constants.textSelectorLists.suited[firstRank].forEach(function (suitedGeneralHandWithFirstRankString) {
      let suitedGeneralHandWithFirstRank = generalHands.find(suitedGeneralHandWithFirstRankString);

      if (suitedGeneralHandWithFirstRank.manuallyRemoved === true) {
        listOfSuitedGeneralHandsManuallyRemovedWithFirstRank.push(suitedGeneralHandWithFirstRank);
      } else if (suitedGeneralHandWithFirstRank.manuallyRemoved === 'partial') {
        suitedGeneralHandWithFirstRank.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyRemoved) {
            listOfSuitedGeneralHandsManuallyRemovedWithFirstRank.push(specificHand);
          }
        });
      }
    });

    return listOfSuitedGeneralHandsManuallyRemovedWithFirstRank;
  },
  _getGroupsOfConsecutiveSuitedGeneralHands: function (suitedGeneralHandsInRange) {
    let groupsOfConsecutiveSuitedGeneralHands = [];
    let currGroupOfConsecutiveSuitedGeneralHands = [];

    suitedGeneralHandsInRange.forEach(function (suitedGeneralHandInRange) {
      let suitedGeneralHandInRangeIsNextInOrder = this._isSuitedGeneralHandInRangeNextInOrder(suitedGeneralHandInRange, _.last(currGroupOfConsecutiveSuitedGeneralHands));

      if (
        (currGroupOfConsecutiveSuitedGeneralHands.length === 0) ||
        (suitedGeneralHandInRangeIsNextInOrder)
      ) {
        currGroupOfConsecutiveSuitedGeneralHands.push(suitedGeneralHandInRange);
      } else {
        groupsOfConsecutiveSuitedGeneralHands.push(currGroupOfConsecutiveSuitedGeneralHands);
        currGroupOfConsecutiveSuitedGeneralHands = [];
        currGroupOfConsecutiveSuitedGeneralHands.push(suitedGeneralHandInRange)
      }
    }, this);

    if (currGroupOfConsecutiveSuitedGeneralHands.length > 0) {
      groupsOfConsecutiveSuitedGeneralHands.push(currGroupOfConsecutiveSuitedGeneralHands);
    }

    return groupsOfConsecutiveSuitedGeneralHands;
  },
  _isSuitedGeneralHandInRangeNextInOrder: function (currSuitedGeneralHand, previousSuitedGeneralHand) {
    if (currSuitedGeneralHand instanceof SpecificHand) {
      return false;
    }

    if (!previousSuitedGeneralHand) {
      return true;
    }

    let currSuitedGeneralHandRank = currSuitedGeneralHand.rankTwo;
    let previousSuitedGeneralHandRank = previousSuitedGeneralHand.rankTwo;

    return utilities.ranks.getRankOneLower(previousSuitedGeneralHandRank) === currSuitedGeneralHandRank;
  },
  _getTextFromGroupsOfConsecutiveSuitedGeneralHands: function (groupsOfConsecutiveSuitedGeneralHands) {
    let textFromGroupsOfConsecutiveSuitedGeneralHands = '';

    groupsOfConsecutiveSuitedGeneralHands.forEach(function (groupOfConsecutiveSuitedGeneralHands) {
      textFromGroupsOfConsecutiveSuitedGeneralHands += this._getTextFromGroupOfConsecutiveSuitedGeneralHands(groupOfConsecutiveSuitedGeneralHands) + ', ';
    }, this);

    return textFromGroupsOfConsecutiveSuitedGeneralHands;
  },
  _getTextFromGroupOfConsecutiveSuitedGeneralHands: function (groupOfConsecutiveSuitedGeneralHands) {
    let firstSuitedGeneralHand = groupOfConsecutiveSuitedGeneralHands[0];
    let lastSuitedGeneralHand = _.last(groupOfConsecutiveSuitedGeneralHands);
    let biggestPossibleSecondRank = utilities.ranks.getRankOneLower(firstSuitedGeneralHand.rankOne);
    let secondRankOfFirstSuitedGeneralHand = firstSuitedGeneralHand.rankTwo;
    let secondRankOfLastSuitedGeneralHand = lastSuitedGeneralHand.rankTwo;

    if (groupOfConsecutiveSuitedGeneralHands.length === 1) {
      return firstSuitedGeneralHand.string;
    } else {
      return firstSuitedGeneralHand.string + '-' + lastSuitedGeneralHand.string;
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/text/get-text-from-general-hands/get-text-from-suited-general-hands.js